





































































import DatasourceServices, { DatasourceDto } from '@/services/datasource';
import { Vue,Component, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component({

})
export default class ColumnConfig extends Vue {
  @PropSync('tableId') syncTableId! : number;
  @PropSync('formData') syncFormData! : DatasourceDto;

  dsSrv = new DatasourceServices();
  childShow = true;
  visible = false;
  loading = false;
  selectedRowKeys: number[] = [];
  data: any = [];
  columns = [{
      title: '字段物理名',
      dataIndex: 'columnNameEn',
      key: 'columnNameEn',
      width: 120,
    },
    {
      title: '字段逻辑名',
      dataIndex: 'columnNameCn',
      key: 'columnNameCn',
      width: 120,
      scopedSlots: { customRender: 'nameCn' },
    },
    {
      title: '字段物理类型',
      dataIndex: 'dataTypeEn',
      key: 'dataTypeEn',
      width: 80,
    },
    {
      title: '字段逻辑类型',
      dataIndex: 'dataTypeCn',
      key: 'dataTypeCn',
      width: 80,
    },
    {
      title: '主键',
      dataIndex: 'pkFlag',
      key: 'pkFlag',
      width: 80,
      scopedSlots: { customRender: 'switch' },
    },
    {
      title: '启用',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      scopedSlots: { customRender: 'switch' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 50,
      scopedSlots: { customRender: 'operation' },
    },
  ];

  mounted() {
    
    this.getDataList();
  }

  onSelectChange(selectedRowKeys: []) {
    this.selectedRowKeys = selectedRowKeys;
  }

  refreshCell() {
    // this.childShow= false;
    // this.$nextTick(() => {
    //     this.childShow= true;
    // });
  }
  onClose(type : string) {
    this.$emit("onClose", type)
  }

  async onDelete(ids: number[]) {

    let res = await this.dsSrv.deleteColumns(ids);
    this.getDataList();
  }
  async onCellChange(args: string[], record:any) {
    let cfg = {...record}
    cfg.columnNameCn = args[0];
    let res = await this.dsSrv.updateColumn(cfg)
  }
  async getDataList() {
      let res = await this.dsSrv.columns({ tableId_eq: this.syncTableId});
      this.data = res;
      this.childShow= false;
      this.$nextTick(() => {
          this.childShow= true;
      });
  }
  handleBatch(args: any) {
    if (args.key == 'removeAll') {
      this.onDelete(this.selectedRowKeys);
    }
  }
  async initColumn() {
    this.loading = true;
    this.data = await this.dsSrv.initColumns({id : this.syncTableId});
    this.loading = false;
  }
  uploadTemplate(data: any) {
    const formData = new FormData()  
    formData.append('file', data.file)
    formData.set('tableId', this.syncTableId.toString() )
    this.dsSrv.uploadTemplate(formData);
  }
}
